import { UserManager, WebStorageStateStore } from 'oidc-client'
import {store} from './store/store'

class ApplicationUserManager extends UserManager {
    constructor() {
        super({
            authority: 'https://sso.orange-green.cf',
            client_id: 'frontend',
            //popup_redirect_uri: 'https://client.orange-green.cf/static/callback.html',
            redirect_uri: 'https://client.orange-green.cf/static/callback.html',
            response_type: 'code',
            scope: 'openid profile backend identity',
            post_logout_redirect_uri: 'https://client.orange-green.cf/static/logout.html',
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
            automaticSilentRenew: true,
            silent_redirect_uri: "https://client.orange-green.cf/static/silent-renew.html",
            accessTokenExpiringNotificationTime: 60,
            monitorSession: true,
            revokeAccessTokenOnSignout: true,
            stateStore: new WebStorageStateStore({ store: window.sessionStorage })
        })
    }

    async login() {
        await this.signinRedirect()
    }

    async logout() {
        return this.signoutRedirect()
    }

   
}

const applicationUserManager = new ApplicationUserManager()

applicationUserManager.events.addAccessTokenExpiring(function () {
    applicationUserManager.startSilentRenew()
});

applicationUserManager.events.addUserSignedIn(function () {
    store.commit("login", true);
    console.window.log('user login')
});

applicationUserManager.events.addUserSignedOut(function () {
    store.commit("login", false);
    console.window.log('user logout')
});

export { applicationUserManager as default }